<div class="admin-announcement-container">
  <mat-card id="main-mat-card">
      <mat-card-title>
          <h2 class="card-title">Newsfeed Article</h2>
      </mat-card-title>
      <div class="mat-content">
          <form class="form-container" [formGroup]="NewsfeedForm" #newsFeedform="ngForm"
              (ngSubmit)="newsfeedActions()">

              <div id="rowTwo" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="0px" fxLayoutGap="10px">
                  <mat-form-field appearance="outline" fxFlex>
                      <mat-label>Status</mat-label>
                      <mat-select formControlName="StatusID" required>
                          <mat-option></mat-option>
                          <mat-option *ngFor="let itemofStatus of status" [value]="itemofStatus.ID">
                              {{itemofStatus.Name}}
                          </mat-option>
                      </mat-select>
                      <mat-error *ngIf="StatusID.hasError('required')">Status is required</mat-error>
                  </mat-form-field>

                  <mat-form-field appearance="outline" fxFlex>
                      <input matInput [matDatepicker]="publishdate" placeholder="Publish Date"
                          formControlName="publishdate">
                      <mat-datepicker-toggle matSuffix [for]="publishdate"></mat-datepicker-toggle>
                      <mat-datepicker #publishdate></mat-datepicker>
                  </mat-form-field>
              </div>

              <div id="midleTextFields">
                  <mat-form-field id="title" appearance="outline">
                      <input matInput placeholder="Title" formControlName="title" required>
                      <mat-error>Title is required</mat-error>
                  </mat-form-field>
                  <mat-form-field id="headline" appearance="outline">
                      <input matInput placeholder="Headline" formControlName="headlineCtrl" required>
                      <mat-hint>One sentence about the article </mat-hint>
                      <mat-error>Headline is required</mat-error>
                  </mat-form-field>
              </div>
              <div id="quill">
                  <p>Content *</p>
                  <quill-editor [styles]="editorStyle" placeholder="Enter Text" 
                      formControlName="newsfeedContentCtrl" [required] = "true">
                  </quill-editor>
              </div>

              <div class="actions-box">
                  <mat-card-actions>
                      <button class="is-rounded" color="accent" mat-stroked-button [routerLink]="['./preview', id]">
                          <mat-icon>remove_red_eye</mat-icon> <span>Preview</span>
                      </button>
                      <div class="right-buttons">
                          <!-- <button *ngIf="id < 1" mat-flat-button class="is-rounded" [disabled]="newsfeedForm.invalid"
                              color="primary" (click)="addOneFeed()">
                              <span>Save</span>
                          </button> -->
                          <button mat-flat-button class="is-rounded" type="submit" [disabled]="newsFeedform.invalid"
                              color="primary"><span>Save</span> </button>
                          <!-- <button *ngIf="id >= 1" mat-flat-button class="is-rounded" [disabled]="newsfeedForm.invalid"
                              color="primary"><span>Save</span></button> -->
                          <button *ngIf="id <= 0" mat-stroked-button class="is-rounded red" color="primary"
                              type="button" [routerLink]="['../../newsfeed']">
                              <span>Cancel</span>
                          </button>
                          <button *ngIf="id >0" mat-stroked-button class="is-rounded red" color="primary"
                              type="button" [routerLink]="['../../../newsfeed']">
                              <span>Cancel</span>
                          </button>
                          <button mat-stroked-button color="primary" class="is-rounded red" [disabled]="id < 1" (click)="openDialog(id)"
                              type="button">
                              <mat-icon>delete</mat-icon> <span>Delete</span>
                          </button>
                      </div>
                  </mat-card-actions>
              </div>
          </form>
          <mat-card-content class="mat-elevation-z8"> </mat-card-content>
      </div>
  </mat-card>
</div>